
/*멤버 아이템 dom으로 변환하여 반환하는 함수*/
export const getMembersHtmByRecord = (memberArray) => {
    return memberArray && memberArray.map((item) => {
        return getMemberItem(item);
    }).join('');
}

/* 멤버 아이템 단건으로 li 반환*/
export const getMemberItem = (item) => {
    let {
        CMNM = '',
        CNT = '',
        DVSN_NM = '',
        FLNM = '',
        JBCL_NM = '',
        PRFL_PHTG = '',
        RGSN_DTTM = '',
        USER_ID = '',
    } = item

    return `<li class="js-member-item" data-user-id="${USER_ID}" data-last-dttm="${RGSN_DTTM}" data-cnt="${CNT}">
                <span class="member-box">
                    <span class="js-participant-profile thumbnail" ${ListHelper.setProfile(PRFL_PHTG)}></span>
                </span>
                <dl class="post-author-info">
                    <dt>
                        <b class="js-participant-name author ellipsis js-mouseover js-over-tooltip" mouseover-text="${Mutil.n2v(FLNM)}">${Mutil.n2v(FLNM)}</b>
                        <em class="position ellipsis js-mouseover js-over-tooltip" mouseover-text="${Mutil.n2v(JBCL_NM)}">${Mutil.n2v(JBCL_NM)}</em>
                    </dt>
                    <dd>
                        <span class="company ellipsis js-mouseover js-over-tooltip" mouseover-text="${Mutil.n2v(CMNM)}">${Mutil.n2v(CMNM)}</span>
                        <span class="team ellipsis js-mouseover js-over-tooltip" mouseover-text="${Mutil.n2v(DVSN_NM)}">${Mutil.n2v(DVSN_NM)}</span>
                    </dd>
                </dl>
            </li>`
}
